
<div>
  <app-banners secaoUrl="onde-encontrar"></app-banners>

  <div class="return-to-search-btn wrap-max-width" *ngIf="isSubmitted">
    <button class="btn btn-light" (click)="returnToSearch()">
      <i class="bi bi-reply-fill"></i>
    </button>
  </div>

  <div *ngIf="loading" class="w-100 d-flex justify-content-center align-items-center mt-5" style="height: 50vh;">
    <span style="margin-right: 5px;">Carregando</span>
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

  <div *ngIf="!isSubmitted && !loading" class="wrap-max-width">
    <div class="container p-4 text-center">
      <div>
        <div
          class="form-group text-center d-flex align-items-center justify-content-center"
        >
          <div class="pt-2 pb-2 w-100 align-items-center d-flex flex-column">
            <div class="title-pages text-center mt-lg-5 mt-md-5 mt-sm-3">
              Onde Encontrar
            </div>

            <div
              class="subtitle-title-pages text-center mt-lg-1 mb-lg-4 mt-md-1 mb-md-4"
            >
              {{ titlePage }}
            </div>

            <div
              class="description-text text-center mt-lg-5 pt-lg-1 mt-md-1 mb-md-4 m-4"
            >
              Selecione abaixo onde deseja comprar
            </div>

            <form
              *ngIf="ondeEncontrarForm"
              [formGroup]="ondeEncontrarForm"
              (ngSubmit)="onSubmit()"
              class="w-100"
              style="max-width: 833px"
            >
              <select
                class="form-select form-select-lg mt-1 mb-3"
                formControlName="estado"
                style="max-width: 833px"
              >
                <option value="" disabled [selected]="stateSelected == 'ALL'">
                  Estado
                </option>
                <option *ngFor="let state of listStates" [value]="state.sigla">
                  {{ state.nome }}
                </option>
              </select>

              <select
                class="form-select form-select-lg mt-1 mb-3"
                formControlName="cidade"
                style="max-width: 833px"
              >
                <option
                  value="ALL"
                  [selected]="citySelected == 'ALL' || listCities.length == 0"
                >
                  Todas as cidades
                </option>
                <option *ngFor="let city of listCities" [value]="city">
                  {{ city }}
                </option>
              </select>

              <select
                class="form-select form-select-lg mt-1 mb-3"
                formControlName="bairro"
                style="max-width: 833px"
              >
                <option
                  value="ALL"
                  [selected]="!(listNeighborhoods.length > 0)"
                >
                  Todos os Bairros
                </option>
                <option
                  *ngFor="let neighborhoods of listNeighborhoods"
                  [value]="neighborhoods"
                >
                  {{ neighborhoods }}
                </option>
              </select>

              <button
                type="submit"
                class="btn-submit-form"
                [disabled]="!ondeEncontrarForm.valid"
              >
                Buscar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isSubmitted && !loading">
    <div class="container p-5 mt-4 text-center">
      <div class="subtitle-text-submit text-center">
        Lojistas e Revendedores em
      </div>

      <div class="title-pages-submit">
        {{
          citySelected !== "ALL"
            ? (citySelected + " - " + stateSelected | uppercase)
            : stateSelectedName
        }}
      </div>

      <div
        *ngIf="citySelected !== 'ALL'"
        class="description-text-submit text-center"
      >
        {{
          neighborhoodSelected === "ALL"
            ? "Todos os Bairros"
            : neighborhoodSelected
        }}
      </div>
    </div>

    <div class="wrap-max-width" style="min-height: 600px;">
      <app-cards-cliente
        [isResellers]="true"
        [resellers]="resellers"
        [resellersGold]="resellersGold"
      ></app-cards-cliente>
    </div>
  </div>

</div>




